import SvgIcon from "../../../../../../parts/SvgIcon";
import ToolTip from "../../../../../../parts/tooltip-portal";

const Notes = ({
  exerciseNotes,
  exerciseId,
  editDayMode,
  editable,
  handleInput,
}) =>
  exerciseNotes || (editDayMode && editable) ? (
    <div
      className={`coach-note-container${
        editDayMode && !editable ? " not-editable" : ""
      }`}
    >
      <div className="coach-note">
        <SvgIcon src="/img/new-icons/message-icon.svg" alt="notes" />
        {!editDayMode || !editable ? (
          <ToolTip
            body={
              !editDayMode
                ? exerciseNotes
                : "This exercise has already been completed, cannot edit"
            }
            forNotes={true}
            childrenContainerClass="tooltip-edit-mode"
          >
            <p className="p4">{exerciseNotes}</p>
          </ToolTip>
        ) : (
          <textarea
            id={`exercise-${exerciseId}-notes`}
            type="text"
            value={exerciseNotes}
            onChange={(evt) => {
              evt.preventDefault();
              handleInput({
                value: evt.target.value,
                field: "notes",
                exerciseId,
              });
            }}
            placeholder="Enter note here"
          />
        )}
      </div>
    </div>
  ) : (
    false
  );

export default Notes;
